import { Component, Inject, OnInit } from '@angular/core';
import { WebcamService } from '../services/webcam.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditWebcamComponent } from '../edit-webcam/edit-webcam.component';


@Component({
  selector: 'app-delete-webcam',
  templateUrl: './delete-webcam.component.html',
  styleUrls: ['./delete-webcam.component.scss']
})
export class DeleteWebcamComponent implements OnInit {
  webcamId: number;
  businessID: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditWebcamComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _webcamService: WebcamService) {
    this.webcamId = data.webcamId;
    this.businessID = data.businessID;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._webcamService.deleteWebcam(this.businessID, this.webcamId);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
